import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import GenerateFormModal from './GenerateFormModal'
import useFormGeneration from './useFormGeneration'
import useSharingOptions from './useSharingOptions'
import { builderLinkFor } from './formGeneration'

const GenerateFormFromDocument = ({
  buildingPassportId = null,
  targetType = null,
  targetId = null,
  children
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [chosenOrganisation, setChosenOrganisation] = useState(null)
  const { options: organisationOptions, loading: organisationsLoading } = useSharingOptions(open)
  const needsOrganisation = organisationOptions.length > 1

  const { generation, uploading, uploadError, timedOut, start, reset } = useFormGeneration({ watching: open })

  const openDraft = useCallback(() => {
    const link = builderLinkFor(generation)
    if (link) navigate(link)
  }, [generation, navigate])

  const handleOpen = useCallback(() => setOpen(true), [])

  const handleClose = useCallback(() => {
    setOpen(false)
    if (generation && (generation.status === 'failed' || generation.status === 'ready' || timedOut)) reset()
  }, [generation, timedOut, reset])

  const handleFile = file => {
    start(file, {
      buildingPassportId,
      organisationId: needsOrganisation ? chosenOrganisation : null,
      targetType,
      targetId
    })
  }

  return (
    <>
      {children(handleOpen)}
      {open && (
        <GenerateFormModal
          generation={generation}
          uploading={uploading}
          uploadError={uploadError}
          timedOut={timedOut}
          organisationOptions={organisationOptions}
          organisationsLoading={organisationsLoading}
          needsOrganisation={needsOrganisation}
          organisationId={chosenOrganisation}
          onOrganisationChange={setChosenOrganisation}
          onFile={handleFile}
          onOpenDraft={openDraft}
          onTryAgain={reset}
          onClose={handleClose}
        />
      )}
    </>
  )
}

export default GenerateFormFromDocument

export const FormGenButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #0C1229;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  svg { font-size: 18px; color: #1f8b98; flex: 0 0 auto; }

  &:hover { background: #f1f5f9; border-color: #94a3b8; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`

export const FormGenLink = styled.button`
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 2px;
  border: none;
  background: none;
  color: #1f8b98;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  align-self: flex-start;

  &:hover { color: #0C1229; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; border-radius: 4px; }
`
